import React from 'react';
import ReactDOM from 'react-dom';
import styles from './ConfirmDialog.module.css';

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!open) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      className={styles.overlay}
      onClick={loading ? undefined : onCancel}
      role="presentation"
    >
      <div
        className={styles.dialog}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'confirm-dialog-title' : undefined}
      >
        {title ? (
          <h2 id="confirm-dialog-title" className={styles.title}>
            {title}
          </h2>
        ) : null}
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmDialog;
